module.exports = __webpack_public_path__ + "img/shebeistatus1.414fb5b9.jpg";